<template>
<!-- 收银票台管理 -->
    <div>
        <content-view class="ticketDesk" v-show="$utils.renderWhen(this,'cashierPlatform')">
        <div slot="header">
            <a-form :form="form" layout="inline">
                <a-form-item label="票台名称">
                    <a-input placeholder="请输入" v-decorator="['name']" @pressEnter="search"></a-input>
                </a-form-item>
                <a-form-item label="状态" >
                    <a-select v-decorator="['isEnable']" placeholder="请选择" allowClear  @select="search">
                        <a-select-option :value="1">使用中</a-select-option>
                        <a-select-option :value="0">已冻结</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item class="wrap-header-button">
                    <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                    <a-button @click="handleReset">重置</a-button>
                </a-form-item>
            </a-form>
        </div>
        <div v-if="shopId != -1" class="wrap-container-in">
            <a-row>
                <a-col :span="21">
                    <a-alert class="mr16 mb16" type="info" show-icon description='若您新建票台后无法展示待售门票，请到“总平台管理-票券管理”找到目标票券，先临时下架后编辑票券中的“是否在门店收银台售卖”信息，保存后上架，即可在本页面的“票券信息”配置门票销售情况'></a-alert>
                </a-col>
                <a-col :span="3">
                    <a-button v-if="getBtnByAuth('addCashierDesk')" type="primary" class="mt16 mb16" @click="toAddTicketDesk">新增收银票台</a-button>
                </a-col>
            </a-row>
            <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :pagination="pagination"
                @change="changePage"
                :rowKey="record => record.id"
                :loading="loading"
            >
                <span slot="index" slot-scope="a, b, index">{{index+1}}</span>
                <span slot="state" slot-scope="a, row">{{row.isEnable ? '使用中' : '已冻结'}}</span>
                <span slot="action" slot-scope="a, row">
                    <span v-if="getBtnByAuth('updateCashierDesk')">
                        <a class="text-primary" @click="toUpdateTicketDesk(row)" >编辑</a>
                        <a-divider type="vertical" />
                    </span>
                    <span v-if="getBtnByAuth('cashierSaleInfo')">
                        <a class="text-primary" @click="toSellTicketDesk(row.id, 1)">票券信息</a>
                        <a-divider type="vertical" />
                    </span>
                    <span v-if="getBtnByAuth('cashierRetailInfo')">
                        <a class="text-primary" @click="toSellTicketDesk(row.id, 2, row.warehouseName)">零售信息</a>
                        <a-divider type="vertical" />
                    </span>
                    <span v-if="getBtnByAuth('cashierStoreValueInfo')">
                        <a class="text-primary" @click="toSellTicketDesk(row.id, 3)">储值卡信息</a>
                        <a-divider type="vertical" />
                    </span>
                    <template>
                        <a class="text-primary" @click="openChangePrintModal(row)">打印机信息</a>
                        <a-divider type="vertical" />
                    </template>
                    <a-popconfirm
                        v-if="getBtnByAuth('stateCashier')"
                        :title="'确定将该票台'+(row.isEnable ? '冻结' : '解冻')+'吗?'"
                        @confirm="ticketDeskState(row.id, row.isEnable)"
                        >
                        <a class="text-primary">{{row.isEnable ? '冻结' : '解冻'}}</a>
                    </a-popconfirm>
                </span>
            </a-table>
        </div>
		<a-empty v-else>
			<span slot="description" class="font-big22">请切换到各门店查看</span>
		</a-empty>
        </content-view>
        <!-- 打印机类型更改-->
        <a-modal
        :visible="printChangeVisible"
        title="切换确认"
        @ok="updatePrintType"
        @cancel="printChangeVisible = false"
        centered
        :width="400"
        :confirmLoading="printChangeLoading"
        :maskClosable="false"
        :destroyOnClose="true"
        >
            <a-form :form="printChangeForm">
                <a-form-item label="请选择打印机型号" :label-col="{span: 10}" :wrapper-col="{span: 13}" class="mt16">
                    <a-select style="width: 100%;" placeholder="请选择" v-decorator="['printType',{rules:[{required: true, message: '请选择'}], initialValue: 2}]">
                        <a-select-option :value="2">
                            80mm
                        </a-select-option>
                        <a-select-option :value="1">
                            58mm
                        </a-select-option>
                    </a-select>
                </a-form-item>
            </a-form>
        </a-modal>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import { mapGetters } from "vuex";
    //  默认表头
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "票台名称",
        dataIndex: "name"
    },
    {
        title: "票台账号",
        dataIndex: "account"
    },
    {
        title: "票台密码",
        dataIndex: "password"
    },
    {
        title: "状态",
        dataIndex: "state",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "操作",
        scopedSlots: { customRender: "action" }
    }]
    export default {
        name: "cashierPlatform",
        components: {},
        props: {},
        data() {
            return {
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                printChangeVisible: false,
                printChangeLoading: false,
                currentPlatFormId: null,
                loading: false
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            handleReset () {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },

            // 获取票台列表
            getList() {
                if(!this.shopId || this.loading){
                    return false
                };
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.loading = true;
                    values.isEnable && (values.isEnable = Boolean(values.isEnable));
                    this.$api.ticketDesk.cashPayPlatform({
                        body: {
                            ...values,
                            shopId: this.shopId,
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize
                        }
                    }).then(res => {
                        this.loading = false;
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },

            // 修改状态
            ticketDeskState(id, isEnable) {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                this.$api.ticketDesk[isEnable ? 'counterFreeze' : 'counterUnfreeze']({
                    params: {
                        id: id
                    }
                }).then(res => {
                    this.$message.success('操作成功', 2);
                    this.loading = false;
                    this.getList();
                }).catch(err =>{
                    ths.loading = false;
                })
            },

            // 去新增
            toAddTicketDesk() {
                this.$router.push({ name: "addCashierDesk"});
            },

            // 去编辑
            toUpdateTicketDesk(row) {
                this.$router.push({ name: "updateCashierDesk", params: {id: row.id}});
            },

            // 去售票信息
            toSellTicketDesk(id, type, warehouseName) {
                if (type == 1) {
                    this.$router.push({ name: "cashierSaleInfo", params: {id: id}});
                } else if (type == 2) {
                    this.$router.push({ name: "cashierRetailInfo", params: {rid: id, warehouseName}});
                } else if (type == 3) {
                    this.$router.push({ name: "cashierStoreValueInfo", params: {id: id}});
                }
            },
            openChangePrintModal(row) {
                this.currentPlatFormId = row.id;
                this.printChangeVisible = true;
                setTimeout(() => {
                    this.printChangeForm.setFieldsValue({printType: row.printType});
                }, 50)
            },
            updatePrintType() {
                this.printChangeForm.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return false;
                    }
                    this.printChangeLoading = true;
                    this.$api.ticketDesk.updateCounter({
                        body: {
                            id: this.currentPlatFormId,
                            printType: values.printType
                        }
                    }).then((res) => {
                        this.printChangeLoading = false;
                        this.printChangeVisible = false;
                        this.$message.success('操作成功！');
                        this.getList();
                    }).catch((err) => {
                        this.printChangeLoading = false;
                    });
                });
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.printChangeForm = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getList();
        },
        watch: {
            '$route'(val) {
                val.name == 'cashierPlatform' && this.getList();
            },
            'shopId'() {
                this.getList();
            }
        }
    };
</script>
<style lang="scss">
.ticketDesk {
  .wrap-header-button {
    width: auto;
  }
  .ant-modal-footer {
    border-top: 0;
    padding: 8px 0;
    text-align: right;
    border-radius: 0 0 4px 4px;
  }
}
</style>